import { db } from "./db.js";
import { ref } from "vue";
import { isAdminOrOwner } from "./permissions.js";

// ==================== CREATE ====================
function createLog(firmId, data) {
  const ref = db.collection(`firms/${firmId}/logs`).doc();
  return ref.set(data);
}

// ==================== READ ====================

async function getLogs(firmId) {
  const logs = ref([]);
  const unsubscribe = db.collection(`firms/${firmId}/logs`)
    .orderBy("createdAt", "desc")
    .onSnapshot((snapshot) => {
      logs.value = snapshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
    });
  return { logs, unsubscribe };
}

async function getTrademarkLogs(firmId) {
  const logs = ref([]);
  const unsubscribe = db.collection(`firms/${firmId}/additions/tm-addition/trademark-logs`)
    .orderBy("createdAt", "desc")
    .onSnapshot((snapshot) => {
      logs.value = snapshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
    });
  return { logs, unsubscribe };
}

async function getLogsOfUser(firmId, userId) {
  const logs = ref([]);
  const is_admin_owner = await isAdminOrOwner(userId, firmId);

  return new Promise((resolve, reject) => {
    const collectionRef = db.collection(`firms/${firmId}/logs`);
    let query;

    if (is_admin_owner) {
      query = collectionRef;
    } else {
      query = collectionRef.where("assigned", "array-contains", userId);
    }

    const unsubscribe = query.onSnapshot((querySnapshot) => {
      logs.value = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      sortLogsByCreatedAt(logs.value);
      resolve({ logs, unsubscribe }); // Resolve with logs and unsubscribe function
    }, reject);
  });
}

// sort logs by deadline
function sortLogsByCreatedAt(logs) {
  logs.sort(function (a, b) {
    var keyA = a.deadline != null ? a.createdAt.toDate() : new Date("1800-01-01"),
      keyB = b.deadline != null ? b.createdAt.toDate() : new Date("1800-01-01");
    // Compare the 2 dates
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    return 0;
  });
}

async function getLogsByTime(firmId, time) {
  const logs = ref([]);
  const unsubscribe = db.collection(`firms/${firmId}/logs`)
    .orderBy("createdAt", "desc")
    .onSnapshot((snapshot) => {
      logs.value = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((log) => log.createdAt.toMillis() >= time.toMillis() && log.status !== "error");
    });
  return { logs, unsubscribe };
}

async function getLogsByApplicationId(firmId, applId) {
  const logs = ref([]);
  await db.collection(`firms/${firmId}/logs`)
    .where("applId", "==", applId)
    .get()
    .then((querySnaptshot) => {
      logs.value = querySnaptshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
      });
    });
  return logs;
}

async function getLogsByStatus(firmId, status) {
  const logs = ref([]);
  db.collection(`firms/${firmId}/logs`)
    .where("status", "==", status)
    .onSnapshot((snapshot) => {
      logs.value = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    });
  return logs;
}

// ==================== NO UPDATE ALLOWED ====================

async function updateLog(firmId, logId, data, transaction = null) {
  const logRef = db.doc(`firms/${firmId}/logs/${logId}`);
  if (transaction) {
    transaction.update(logRef, data);
  } else {
    await logRef.update(data);
  }
}

// ==================== NO DELETE ALLOWED ====================

export {
  createLog,
  getLogs,
  getTrademarkLogs,
  getLogsByStatus,
  getLogsByTime,
  getLogsByApplicationId,
  getLogsOfUser,
  updateLog
};
